<template>
  <b-modal
    id="deposit-limit-modal"
    title="Deposit Limits"
    hide-footer
    centered
    size="sm"
    body-class="modal-body-scrollable"
    @shown="fetchDepositLimits"
  >
    <div>
      <!-- LOADING SKELETON -->
      <div v-if="isLoading">
        <div
          v-for="n in 3"
          :key="'skeleton-' + n"
          class="py-2 d-flex justify-content-between align-items-center"
          style="border-bottom: 1px solid #e5e5e5"
        >
          <div class="w-75">
            <b-skeleton width="80%" class="mb-1"></b-skeleton>
            <b-skeleton width="60%"></b-skeleton>
          </div>

          <b-skeleton width="70px"></b-skeleton>
        </div>
      </div>

      <div v-else-if="limits.length === 0" class="text-center">
        <feather-icon icon="InfoIcon" size="48" class="text-muted mb-2" />
        <div class="text-muted">No deposit limits set for this user.</div>
      </div>

      <div
        v-else
        v-for="(item, index) in limits"
        :key="index"
        class="py-1 d-flex justify-content-between align-items-center"
        :style="{
          borderBottom:
            index === limits.length - 1 ? 'none' : '1px solid #e5e5e5',
        }"
      >
        <div>
          <div class="text-black font-weight-bold">
            {{ item.period }} Day Limit
          </div>
          <div class="text-muted">
            Next renewal: {{ format(new Date(item.endTime), "dd/MM/yyyy") }}
          </div>
        </div>

        <div class="text-right">
          <div class="text-black font-weight-bold">
            {{ formatCurrencyBuiltInFunc(item.amount) }}
          </div>
          <div class="text-muted small" v-if="item.quota != null">
            Remaining: {{ formatCurrencyBuiltInFunc(item.quota) }}
          </div>
        </div>
      </div>

      <!-- FOOTER -->
      <p class="text-center text-muted" v-if="!isLoading">
        Customer must change their deposit limits in their account settings.
      </p>
    </div>
  </b-modal>
</template>

<script>
import { BModal, BSkeleton } from "bootstrap-vue";
import { mapActions } from "vuex";
import { format } from "date-fns";
import { formatCurrencyBuiltInFunc } from "@/helpers/utils";

export default {
  components: { BModal, BSkeleton },

  data() {
    return {
      limits: [],
      isLoading: true,
    };
  },
  methods: {
    ...mapActions("user/detail", ["getDepositLimitByUser"]),
    format,
    formatCurrencyBuiltInFunc,

    async fetchDepositLimits() {
      this.isLoading = true;

      const depositLimits = await this.getDepositLimitByUser(
        this.$route.params.id
      );

      if (depositLimits)
        this.limits = depositLimits.sort((a, b) => a.period - b.period);
      this.isLoading = false;
    },
  },
};
</script>

<style>
.modal-body-scrollable {
  max-height: 70vh;
  overflow-y: auto;
}
</style>
